export default function Observable() {
  return function FieldDecorator<C, V>(
    target: any,
    ctx: ClassFieldDecoratorContext<C, V>
  ) {
    const fieldName = ctx.name.toString();

    return function (this: any, value: any) {
      // store information that this field is observed
      if (this.__observedFields === undefined) {
        this.__observedFields = new Set();
      }

      this.__observedFields.add(fieldName);

      return value;
    };
  };
}
